export function formatBoostPartiallyAppliedMessage(numberOfPicksBoostAppliedOn, dictionary) {
    return numberOfPicksBoostAppliedOn > 1
        ? dictionary.myBetsDictionary.BoostPartiallyApplied.replace("{0}", numberOfPicksBoostAppliedOn.toString())
        : dictionary.myBetsDictionary.BoostPartiallyApplied1Pick.replace("{0}", numberOfPicksBoostAppliedOn.toString());
}
//# sourceMappingURL=formatBoostPartiallyAppliedMessage.js.map